import { render, staticRenderFns } from "./addProjectContract.vue?vue&type=template&id=23c65670&scoped=true&"
import script from "./addProjectContract.vue?vue&type=script&lang=js&"
export * from "./addProjectContract.vue?vue&type=script&lang=js&"
import style0 from "./addProjectContract.vue?vue&type=style&index=0&id=23c65670&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c65670",
  null
  
)

export default component.exports